<div class="d-flex flex-column widget-form-participant-container">
    <div class="d-flex justify-content-around">
        <app-chart-circle-somple [percentage]="sort[0]" [text]="select1">
            {{ sort[0] | number : '1.0-0' }}%
        </app-chart-circle-somple>

        <app-chart-circle-somple [percentage]="sort[1]" [text]="select2">
            {{ sort[1] | number : '1.0-0' }}%
        </app-chart-circle-somple>
        @if (oddsLength === 3) {
        <app-chart-circle-somple [percentage]="sort[2]" [text]="select3">
            {{ sort[2] | number : '1.0-0' }}%
        </app-chart-circle-somple>
        }
    </div>
</div>

@if (marketsAndOdds && marketsAndOdds.length > 0) {
<div class="my-3">
    <div class="d-flex flex-wrap justify-content-around">
        @for (odd of marketsAndOdds; track $index) {
        <div
            class="text-center mx-2 my-2"
            [style.flexBasis.%]="15 * odd.odds.length"
            [style.minWidth.%]="15 * odd.odds.length"
        >
            <span class="font-weight-bold emph-text-node app-no-wrap">
                {{ 'web.odd_market_title_' + odd.marketName | translate }}</span
            >
            <div class="d-flex justify-content-between">
                @for (odd of odd.odds; track $index) {
                <div>
                    <app-chart-circle-somple
                        [percentage]="odd.percentage"
                        [text]="'web.odd_market_title_' + odd.name | lowercase | translate"
                    >
                        {{ odd.percentage | number : '1.0-0' }}%
                    </app-chart-circle-somple>
                </div>
                }
            </div>
        </div>
        }
    </div>
</div>
}
